import React from "react";
import { formatDateTransfer } from "../../common/FormatDate/FormatDate";

export const DefaultMemoizedCell = React.memo(({ value }: { value: any }) => {
  console.log("Cell re-render:", value);
  return <>{value}</>;
});

export const DefaultMemoizedCellDate = React.memo(
  ({ value }: { value: any }) => {
    console.log("Cell re-render:", value);
    return <>{value && formatDateTransfer(value)}</>;
  }
);
export const DefaultMemoizedCellDynamic = React.memo(
  ({ value }: { value: any }) => {
    console.log("Cell re-render:", value);
    return <>{value && formatDateTransfer(value)}</>;
  }
);
export const DynamicCellRenderer = React.memo(
  ({
    value,
    row,
    Component,
    componentProps = {},
  }: {
    value: any;
    row?: any;
    Component: React.ElementType;
    componentProps?: Record<string, any>;
  }) => {
    if (!value) return null; // Không render nếu không có giá trị

    return <Component value={value} row={row} {...componentProps} />;
  }
);
